import { TableProps } from "antd"
import { formatCurrency, formatNumber } from "./string-utils"
import { listDataPacks } from "./package-utils"
import {TRANSACTIONTYE_REGADDON_UPGRADE} from "../assets/constants/constants";

export const networkOptions = [
    {
        label: 'Data sponsor',
        value: 'datasponsor',
        children: [
            {
                value: 'data_sponsor',
                title: 'data_sponsor',
            },
            {
                value: 'datasponsor_zynet',
                title: 'datasponsor_zynet',
            },
        ],
    },
    {
        label: 'Affapi',
        value: 'affapi',
        children: [
            {
                value: 'aff_zynet',
                title: 'aff_zynet',
            },
            {
                value: 'aff_sann',
                title: 'aff_sann',
            },
        ],
    },
    {
        label: 'TDM Zynet',
        value: 'TDM_ZYNET',
    },
    {
        label: 'VDS',
        value: 'vds',
        children: [
            {
                value: 'vds-data-sponsor',
                title: 'vds-data-sponsor',
            },
            {
                value: 'vds-ds-postpaid',
                title: 'vds-ds-postpaid',
            },
        ],
    },
]

export const dataTypeColumns: TableProps<any>['columns'] = [
    {
        key: 'id',
        title: 'STT',
        render: (_text, _record, index) => index + 1,
    },
    {
        key: 'dataType',
        title: "Nhóm gói cước",
        dataIndex: 'dataType',
        render: dataType => renderType(dataType),
    },
    {
        key: 'total_pack',
        title: "Tổng số gói",
        dataIndex: 'detail',
        render: detail => detail.length,
    },
    {
        key: 'totalAmount_current',
        title: "Đã bán trong tháng",
        dataIndex: 'totalAmount_current',
        render: totalAmount_current => formatNumber(Number(totalAmount_current || 0)),
    },
    {
        key: 'totalAmount_previous',
        title: "Đã bán tháng trước",
        dataIndex: 'totalAmount_previous',
        render: totalAmount_previous => formatNumber(Number(totalAmount_previous || 0)),
    },
    {
        key: 'count_current',
        title: "Doanh thu trong tháng",
        dataIndex: 'count_current',
        render: count_current => formatCurrency(Number(count_current || 0)),
    },
    {
        key: 'count_previous',
        title: "Doanh thu tháng trước",
        dataIndex: 'count_previous',
        render: count_previous => formatCurrency(Number(count_previous || 0)),
    },
    {
        key: 'count',
        title: "Chênh lệch doanh thu",
        render: (_, data: any) => formatNumber(Number(data.count_current || 0) - Number(data.count_previous || 0)),
    },
    // Hidden is this version
    // {
    //     key: 'totalProfit_current',
    //     title: "NET trong tháng",
    //     dataIndex: 'totalProfit_current',
    //     render: totalProfit_current => formatCurrency(Number(totalProfit_current || 0)),
    // },
    // {
    //     key: 'totalProfit_previous',
    //     title: "NET tháng trước",
    //     dataIndex: 'totalProfit_previous',
    //     render: totalProfit_previous => formatCurrency(Number(totalProfit_previous || 0)),
    // },
]

export const dataTypeDayColumns: TableProps<any>['columns'] = [
    {
        key: 'id',
        title: 'STT',
        render: (_text, _record, index) => index + 1,
    },
    {
        key: 'dataType',
        title: "Nhóm gói cước",
        dataIndex: 'dataType',
        render: dataType => renderType(dataType),
    },
    {
        key: 'total_pack',
        title: "Tổng số gói",
        dataIndex: 'detail',
        render: detail => detail.length,
    },
    {
        key: 'totalAmount_current',
        title: "Đã bán trong ngày",
        dataIndex: 'totalAmount_current',
        render: totalAmount_current => formatNumber(Number(totalAmount_current || 0)),
    },
    {
        key: 'totalAmount_previous',
        title: "Ngày trong tháng trước",
        dataIndex: 'totalAmount_previous',
        render: totalAmount_previous => formatNumber(Number(totalAmount_previous || 0)),
    },
    {
        key: 'count_current',
        title: "Doanh thu trong ngày",
        dataIndex: 'count_current',
        render: count_current => formatCurrency(Number(count_current || 0)),
    },
    {
        key: 'count_previous',
        title: "Ngày trong tháng trước",
        dataIndex: 'count_previous',
        render: count_previous => formatCurrency(Number(count_previous || 0)),
    },
    {
        key: 'count',
        title: "Chênh lệch doanh thu",
        render: (_, data: any) => formatNumber(Number(data.count_current || 0) - Number(data.count_previous || 0)),
    },
    // Hidden is this version
    // {
    //     key: 'totalProfit_current',
    //     title: "NET trong ngày",
    //     dataIndex: 'totalProfit_current',
    //     render: totalProfit_current => formatCurrency(Number(totalProfit_current || 0)),
    // },
    {
        key: 'totalProfit_previous',
        title: "Ngày trong tháng trước",
        dataIndex: 'totalProfit_previous',
        render: totalProfit_previous => formatCurrency(Number(totalProfit_previous || 0)),
    },
]

export const renderPackageMonthColumns = (detailPackage: any) => {
    const packageMonthColumns: TableProps<any>['columns'] = [
        {
            render: (_text, _record, index) => index + 1,
        },
        {
            key: 'packageName',
            title: "Tên gói cước",
            dataIndex: 'packageName',
        },
        {
            key: 'dataPack',
            title: "Mã gói cước",
            dataIndex: 'dataPack',
        },
        {
            key: 'price',
            title: "Giá bán",
            dataIndex: 'price',
            render: price => formatCurrency(price),
        },
        {
            key: 'totalAmount_current',
            title: "Đã bán trong tháng",
            dataIndex: 'totalAmount_current',
            render: totalAmount_current => formatNumber(Number(totalAmount_current) || 0),
        },
        {
            key: 'totalAmount_previous',
            title: "Đã bán tháng trước",
            dataIndex: 'totalAmount_previous',
            render: totalAmount_previous => formatNumber(Number(totalAmount_previous) || 0),
        },
        {
            key: 'count_current',
            title: "Doanh thu trong tháng",
            dataIndex: 'count_current',
            render: count_current => formatCurrency(Number(count_current || 0)),
        },
        {
            key: 'count_previous',
            title: "Doanh thu tháng trước",
            dataIndex: 'count_previous',
            render: count_previous => formatCurrency(Number(count_previous || 0)),
        },
        {
            key: 'count',
            title: "Chênh lệch doanh thu",
            render: (_, data: any) => formatNumber(Number(data.count_current || 0) - Number(data.count_previous || 0)),
        },
        // Hidden is this version
        // {
        //     key: 'profit',
        //     title: "NET trong tháng",
        //     render: data => formatCurrency((data.price - data.priceSale) * (Number(data.totalAmount_current) || 0)),
        // },
        // {
        //     key: 'profit',
        //     title: "NET tháng trước",
        //     render: data => formatCurrency((data.price - data.priceSale) * (Number(data.totalAmount_previous) || 0) || 0),
        // },
        {
            key: 'total_day',
            title: "Số ngày",
            dataIndex: 'detail',
            render: detail => detail.current?.length,
        },
        {
            key: 'action',
            title: "Chi tiết",
            render: (_, data: any) => detailPackage(data),
        },
    ]
    return packageMonthColumns
}

export const packageDayColumns: TableProps<any>['columns'] = [
    {
        render: (_text, _record, index) => index + 1,
    },
    {
        key: 'packageName',
        title: "Tên gói cước",
        dataIndex: 'packageName',
    },
    {
        key: 'dataPack',
        title: "Mã gói cước",
        dataIndex: 'dataPack',
    },
    {
        key: 'price',
        title: "Giá bán",
        dataIndex: 'price',
        render: price => formatCurrency(price),
    },
    {
        key: 'totalAmount_current',
        title: "Đã bán trong ngày",
        dataIndex: 'totalAmount_current',
        render: totalAmount_current => formatNumber(Number(totalAmount_current) || 0),
    },
    {
        key: 'totalAmount_previous',
        title: "Ngày trong tháng trước",
        dataIndex: 'totalAmount_previous',
        render: totalAmount_previous => formatNumber(Number(totalAmount_previous) || 0),
    },
    {
        key: 'count_current',
        title: "Doanh thu trong ngày",
        dataIndex: 'count_current',
        render: count_current => formatCurrency(Number(count_current || 0)),
    },
    {
        key: 'count_previous',
        title: "Ngày trong tháng trước",
        dataIndex: 'count_previous',
        render: count_previous => formatCurrency(Number(count_previous || 0)),
    },
    {
        key: 'count',
        title: "Chênh lệch doanh thu",
        render: (_, data: any) => formatNumber(Number(data.count_current || 0) - Number(data.count_previous || 0)),
    },
    // Hidden is this version
    // {
    //     key: 'profit',
    //     title: "NET trong ngày",
    //     render: data => formatCurrency((data.price - data.priceSale) * (Number(data.totalAmount_current) || 0) || 0),
    // },
    {
        key: 'profit',
        title: "Ngày trong tháng trước",
        render: data => formatCurrency((data.price - data.priceSale) * (Number(data.totalAmount_previous) || 0) || 0),
    },
]

export const renderType = (type: string) => {
    switch (type) {
        case 'normal':
            return 'Data sponsor'
        case 'change_price':
            return 'Thay đổi giá'
        case 'bundle_video':
            return 'Bundle Video'
        case 'vtvcab':
            return 'VTVcab'
        case 'tv360':
            return 'TV360'
        case 'data_code':
            return 'Data code'
        case 'vtvcab_promotion':
            return 'VTVcab khuyến mãi'
        case 'upgrade':
            return 'Data upgrade'
        default:
            return type
    }
}

export const getInfoChartRatio = (statistics: any) => {
    const partners = statistics?.reduce((acc: any, item: any) => {
        if (!acc[item.cpCode]) {
            acc[item.cpCode] = 0
        }
        acc[item.cpCode] = Number(acc[item.cpCode]) + Number(item.totalAmount * item.price)
        return acc
    }, {}) || []
    const total = Object.values(partners).reduce((sum: any, value) => sum + value, 0)
    return Object.entries(partners).sort((a: any, b: any) => b[1] - a[1]).reduce((acc: any, [key, value]) => {
        acc[key] = ((Number(value) / Number(total)) * 100).toFixed(2)
        return acc
    }, {})
}

export const getInfoChartComparision = (current: any, previous: any) => {
    const currrentPartners = Object.fromEntries(Object.entries(current?.reduce((acc: any, item: any) => {
        if (!acc[item.cpCode]) {
            acc[item.cpCode] = {
                revenue: 0,
                profit: 0,
            }
        }
        const dataPack = listDataPacks.find((dataPack: any) => dataPack.dataPack === item.dataPack && dataPack.pricePartner === item.price)
        acc[item.cpCode].revenue = Number(acc[item.cpCode].revenue) + Number(item.totalAmount * item.price)
        acc[item.cpCode].profit = Number(acc[item.cpCode].profit) + Number(item.totalAmount * (item.price - Number(dataPack?.priceSale || 0)))
        return acc
    }, {})).sort((a: any, b: any) => b[1] - a[1])) || {}
    const previousPartners = Object.fromEntries(Object.entries(previous?.reduce((acc: any, item: any) => {
        if (!acc[item.cpCode]) {
            acc[item.cpCode] = {
                revenue: 0,
                profit: 0,
            }
        }
        const dataPack = listDataPacks.find((dataPack: any) => dataPack.dataPack === item.dataPack && dataPack.pricePartner === item.price)
        acc[item.cpCode].revenue = Number(acc[item.cpCode].revenue) + Number(item.totalAmount * item.price)
        acc[item.cpCode].profit = Number(acc[item.cpCode].profit) + Number(item.totalAmount * (item.price - Number(dataPack?.priceSale || 0)))
        return acc
    }, {})).sort((a: any, b: any) => b[1] - a[1])) || {}
    return Object.keys(currrentPartners).map((key) => ({
        name: key,
        current: currrentPartners[key] || 0,
        previous: previousPartners[key] || 0
    }))
}

export const getInfoChartDetail = (statistics: any) => {
    const partners = statistics?.reduce((acc: any, item: any) => {
        if (!acc[renderType(item.dataType)]) {
            acc[renderType(item.dataType)] = 0
        }
        acc[renderType(item.dataType)] = Number(acc[renderType(item.dataType)]) + Number(item.totalAmount * item.price)
        return acc
    }, {}) || []
    return Object.fromEntries(Object.entries(partners).sort((a: any, b: any) => b[1] - a[1]))
}

export const getInfoPackages = (statistics: any) => {
    if (!statistics || !Array.isArray(statistics)) return []
    const packages = statistics?.reduce((acc: any, item: any) => {
        if (!acc[item.dataPack]) {
            acc[item.dataPack] = []
        }
        acc[item.dataPack].push({ ...item, count: Number(item.totalAmount * item.price) })
        return acc
    }, {})
    const packagesArray = Object.entries(packages).map((item: any) => {
        const count = item[1].reduce((sum: any, value: any) => sum + value.count, 0)
        const totalAmount = item[1].reduce((sum: any, value: any) => sum + value.totalAmount, 0)
        const dataPacks = item[1].reduce((sum: any, value: any) => {
            const dataPack = sum.find((item: any) => item.dataPack === value.dataPack &&
                item.day === value.day && item.month === value.month && item.year === value.year)
            if (!dataPack) {
                sum.push(value)
            } else {
                dataPack.count += value.count
                dataPack.totalAmount += value.totalAmount
            }
            return sum
        }, []).sort((a: any, b: any) => a.day - b.day)
        return {
            dataType: item[1][0].dataType,
            type: item[1][0].type,
            dataPack: item[0],
            packageName: item[1][0].packageName,
            price: item[1][0].price,
            totalAmount,
            count,
            detail: dataPacks,
        }
    }).sort((a: any, b: any) => a.dataType.localeCompare(b.dataType))
    const newPackagesArray = packagesArray.map((item: any) => {
        const dataPack = listDataPacks.find((dataPack: any) => dataPack.dataPack === item.dataPack && dataPack.pricePartner === item.price)
        return {
            ...item,
            priceSale: dataPack?.priceSale,
            originalPrice: dataPack?.originalPrice || item.price,
        }
    })
    const data = newPackagesArray?.reduce((acc: any, item: any) => {
        if (!acc[item.dataType]) {
            acc[item.dataType] = []
        }
        acc[item.dataType].push(item)
        return acc
    }, {})
    return Object.entries(data).map((item: any) => {
        const count = item[1].reduce((sum: any, value: any) => sum + value.count, 0)
        const totalAmount = item[1].reduce((sum: any, value: any) => sum + value.totalAmount, 0)
        const totalProfit = item[1].reduce((sum: any, value: any) => sum + ((value.price - value.priceSale) * value.totalAmount), 0)
        const totalOriginalRevenue = item[1].reduce((sum: any, value: any) => sum + (value.originalPrice * value.totalAmount), 0)
        return {
            dataType: item[0],
            totalProfit,
            totalAmount,
            count,
            totalOriginalRevenue,
            detail: item[1].sort((a: any, b: any) => a.day - b.day),
        }
    })
}

export const aggregateArrays = (current: any, previous: any) => {
    const map = new Map()
    current.forEach(({ dataType, totalProfit, totalAmount, count, totalOriginalRevenue, detail }: any) => {
        map.set(dataType, {
            dataType,
            totalProfit_current: totalProfit,
            totalAmount_current: totalAmount,
            totalOriginalRevenue_current: totalOriginalRevenue,
            count_current: count,
            detail: detail.map((item: any) => ({
                dataType: item.dataType,
                type: item.type,
                packageName: item.packageName,
                dataPack: item.dataPack,
                price: item.price,
                priceSale: item.priceSale,
                totalAmount_current: item.totalAmount,
                totalOriginalRevenue_current: item.originalPrice * item.totalAmount,
                count_current: item.count,
                detail: {
                    current: item.detail
                },
            })),
        })
    })
    previous.forEach(({ dataType, totalProfit, totalAmount, count, totalOriginalRevenue, detail }: any) => {
        if (map.has(dataType)) {
            map.get(dataType).totalProfit_previous = totalProfit
            map.get(dataType).totalAmount_previous = totalAmount
            map.get(dataType).totalOriginalRevenue_previous = totalOriginalRevenue
            map.get(dataType).count_previous = count
            detail.forEach((prev: any) => {
                const detailItem = map.get(dataType).detail.find((item1: any) => item1.packageName === prev.packageName)
                if (detailItem) {
                    detailItem.totalProfit_previous = prev.totalProfit
                    detailItem.totalAmount_previous = prev.totalAmount
                    detailItem.count_previous = prev.count
                    detailItem.detail.previous = prev.detail
                }
            })
        }
    })
    return Array.from(map.values())
}

export const getOriginalRevenueLabel = (data: any) => {
    // Calculate total original revenue once
    const totalOriginalRevenue = data?.reduce(
        (sum: any, value: any) => sum + Number(value.totalOriginalRevenue_current || 0),
        0
    ) || 0;

    // Helper function to calculate revenue by data type
    const calculateRevenueByType = (dataType: string): number => {
        if (!data || !Array.isArray(data)) return 0;

        const UPGRADE_EXCEPTION_PACKS = ['1N_VTVCAB', '3N_VTVCAB'];
        return data.reduce((acc, group) => {
            const groupTotal = group.detail?.reduce((sum: number, item: any) => {

                const isUpgradeItem =
                  item.type === TRANSACTIONTYE_REGADDON_UPGRADE ||
                  UPGRADE_EXCEPTION_PACKS.includes(item.dataPack);

                if (dataType === 'upgrade' && isUpgradeItem) {
                    return sum + (item.totalOriginalRevenue_current || 0);
                }

                if (dataType === 'dataSponsor' && !isUpgradeItem) {
                    return sum + (item.totalOriginalRevenue_current || 0);
                }

                return sum;
            }, 0) || 0;

            return acc + groupTotal;
        }, 0);
    };

    // Helper function to format revenue with percentage
    const formatRevenueWithPercentage = (revenue: number): string => {
        const percentage = totalOriginalRevenue > 0
            ? ((revenue / totalOriginalRevenue) * 100).toFixed(2)
            : '0.00';
        return `${formatCurrency(revenue)} (${percentage}%)`;
    };
    return [
        {
            label: 'Doanh thu theo giá gốc',
            children: formatCurrency(totalOriginalRevenue),
        },
        {
            label: 'Doanh thu theo giá gốc - Đại trà',
            children: formatRevenueWithPercentage(calculateRevenueByType('dataSponsor')),
        },
        {
            label: 'Doanh thu theo giá gốc - Upgrade',
            children: formatRevenueWithPercentage(calculateRevenueByType('upgrade')),
        }
    ];
}